import Mentions from './src/Mentions';
import Option from './src/Option';

Mentions.Option = Option;

export default Mentions;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-mentions/index.js
// module id = 819
// module chunks = 0